import { Empty, Spin } from 'antd';
import { useDestinationPublicSteps } from 'api/destinations.api';
import React from 'react';
import { useDestinationEditor } from './DestinationEditorContext';
import { DestinationPublicStepCard } from './DestinationPublicStepCard';
import styles from './DestinationEditorPublicSteps.module.css';

type DestinationEditorPublicStepsProps = Readonly<{
    isActive: boolean;
}>;

export function DestinationEditorPublicSteps({
    isActive,
}: DestinationEditorPublicStepsProps) {
    const { destination } = useDestinationEditor();
    const { publicSteps, isLoading } = useDestinationPublicSteps(
        isActive ? destination.id ?? null : null,
    );

    if (!isActive || isLoading) {
        return <Spin />;
    }

    if (publicSteps.length === 0) {
        return (
            <div className={styles.emptyState}>
                <Empty description="No public steps yet" />
            </div>
        );
    }

    return (
        <div className={styles.gallery}>
            {publicSteps.map((step) => (
                <DestinationPublicStepCard key={step.step_id} step={step} />
            ))}
        </div>
    );
}
